module.exports = __webpack_public_path__ + "static/img/crap.f1425a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crap.png
// module id = oYxb
// module chunks = 1